import React from "react";
import SingleBar from "../Elements/SingleBar";
import BlockLayout from "../Layout/BlockLayout";
import SvgLayout from "../Layout/SvgLayout";
import ComponentHeader from "../Header/ComponentHeader";
import styled from "styled-components";
import { device } from "../../Util/Breakpoints";
import {
  FiguresWrapper,
  HeadingMunicipality
} from "../../Util/StyleProps";
import { mainColor, oppositeColor, primaryColor, secondaryColor } from "../../Util/Colors";
import { useInView } from "react-intersection-observer";
import {
  calculatePercentage,
  isCurrentYear,
  numberWithSpaces
} from "../../Helpers/CommonHelper";
import EmptySpace from "../Elements/EmptySpace";

const AccommodationContainer = props => {
  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0.5,
    triggerOnce: true
  });

  const { data, sweden, blockColor, scroll } = props;

  let municipality1 = data[0];
  let municipality2 = data[1];

  const lastYear = sweden.accommodation
    ? sweden.accommodation.year
    : "årtal ej tillgängligt";

  let swedenString = sweden
    ? `Genomsnittspriset för sålda småhus i Sverige är 
      ${numberWithSpaces(
        sweden.accommodation.averagePrice
      )} tusen kronor (${lastYear}).`
    : "";

  let total = 100;
  const AnimatedDiv = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #0f0865;
  transform: scale(${props => (props.inView ? 1 : 0.8)});
  transition: transform 2.0s cubic-bezier(0.175, 0.885, 0.275, 1.235);
  border-radius: 1000px;
  padding: 24px 40px;
  text-align: center;
  font-size: 36px;
  font-family: 'Inter';
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.6px;
  width: fit-content;
  margin: auto auto 8px;
  
  @media${device.tablet} {
    font-size: 48px;
    line-height: 54px;
    letter-spacing: -0.7px;
  }

  @media${device.laptop} {
      font-size: 64px;
      line-height: 70px;
      letter-spacing: -0.9px;
  }
  .label{
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.15px;
    white-space: nowrap;
  }
`;
  if (municipality1 && municipality2) {
    total =
      Number(municipality1.averagePrice) + Number(municipality2.averagePrice);
  } else if (municipality1) {
    total = municipality1.averagePrice;
  } else if (municipality2) {
    total = municipality2.averagePrice;
  }

  let maxOffset =
    municipality1 && municipality2
      ? 100 -
        calculatePercentage(
          Math.min(
            Number(municipality1.averagePrice),
            Number(municipality2.averagePrice)
          ),
          total
        )
      : 100;

  const height = 130;
  const width = 100;

  const ariaLabel = municipality => {
    const str = municipality
      ? isCurrentYear(municipality.year)
        ? "är"
        : "var"
      : "";

    return municipality
      ? `Genomsnittspriset för sålda småhus i ${municipality.name} kommun ${str} ${municipality.averagePrice} tusen kronor (år ${municipality.year})`
      : "";
  };

  const svgAriaLabel = municipality =>
    municipality
      ? `Det här stapeldiagramet visar genomsnittliga priset i tusen kronor per sålda småhus i ${municipality.name} kommun.`
      : "";

  return (
    <React.Fragment>
      <BlockLayout background={blockColor}>
        <svg style={{ marginBottom: "32px"}} xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path d="M20.8009 67.3653V42.552H28.0709C28.3625 42.552 28.6434 42.5797 28.9134 42.6353C29.1839 42.6914 29.465 42.7639 29.7567 42.8528L49.4042 50.167C50.7631 50.6797 51.9159 51.4875 52.8625 52.5903C53.8086 53.6925 54.2817 54.9617 54.2817 56.3978C54.2817 56.7589 54.1698 57.0564 53.9459 57.2903C53.7214 57.5242 53.4298 57.6411 53.0709 57.6411H48.6217C47.1945 57.6411 45.7703 57.5386 44.3492 57.3336C42.9286 57.1286 41.5431 56.7995 40.1925 56.3461L33.9809 54.3145L33.1475 56.4878L39.4934 58.6861C41.0662 59.2289 42.6731 59.5806 44.3142 59.7411C45.9553 59.9011 47.607 59.9811 49.2692 59.9811H64.4934C66.5278 59.9811 68.232 60.7225 69.6059 62.2053C70.9798 63.6881 71.6667 65.4808 71.6667 67.5836L47.09 74.9745L20.8009 67.3653ZM5.64087 71.667V42.552H16.9359V71.667H5.64087ZM48.2692 28.0128H51.2817V25.0003H48.2692V28.0128ZM41.6025 28.0128H44.615V25.0003H41.6025V28.0128ZM48.2692 34.6795H51.2817V31.667H48.2692V34.6795ZM41.6025 34.6795H44.615V31.667H41.6025V34.6795ZM58 50.0645C57.4189 48.4878 56.5653 47.1661 55.4392 46.0995C54.3131 45.0333 52.827 44.15 50.9809 43.4495L28.3334 35.007H24.5509V21.9495L46.4425 6.31445L68.3334 21.9495V50.0645H58Z" fill="#1F44FF"/>
        <path d="M48.2692 28.0128H51.2817V25.0003H48.2692V28.0128ZM41.6026 28.0128H44.6151V25.0003H41.6026V28.0128ZM48.2692 34.6795H51.2817V31.667H48.2692V34.6795ZM41.6026 34.6795H44.6151V31.667H41.6026V34.6795ZM58.0001 50.0645C57.419 48.4878 56.5653 47.1661 55.4392 46.0995C54.3131 45.0333 52.827 44.15 50.9809 43.4495L28.3334 35.007H24.5509V21.9495L46.4426 6.31445L68.3334 21.9495V50.0645H58.0001Z" fill="#0F0865"/>
        </svg>
        <ComponentHeader
          heading={"Så mycket kostar våra hus"}
          text={swedenString}
        />
        {municipality1 ? (
          <div ref={ref}>
            <FiguresWrapper maxWidth="900px">
              {municipality1 ? (
                <div style={{ width: "47%", display: "flex", flexDirection: "column", alignItems: "baseline",justifyContent: "flex-end", justifyContent: "space-between", minWidth: "47%" }}>
                  <HeadingMunicipality
                    aria-label={ariaLabel(municipality1)}
                    marginBottom="24px"
                  >
                    {municipality1.name}
                  </HeadingMunicipality>
                  <SingleBar
                    color={mainColor}
                    height={inView && municipality1 && municipality1.averagePrice > 0
                      ? `${(180 * Number(calculatePercentage(municipality1.averagePrice, total)) / 100) + 140}px`
                      : "0px"}
                    inView={inView}
                    value={municipality1 ? Number(municipality1.averagePrice).toLocaleString('sv-SE') : 0}
                    label="tusen kronor"
                    lineColor={mainColor}
                    amount={municipality1.amount}
                  />
                </div>
              ) : (
                <div> </div>
              )}

              {municipality2 ? (
                <div style={{ width: "47%", display: "flex", flexDirection: "column", alignItems: "baseline", justifyContent: "flex-end",justifyContent: "space-between", minWidth: "47%"  }}>
                  <HeadingMunicipality
                    color={secondaryColor}
                    marginBottom="24px"
                    aria-label={ariaLabel(municipality2)}
                  >
                    {municipality2.name}
                  </HeadingMunicipality>
                  <SingleBar
                    color={oppositeColor}
                    height={inView && municipality2 && municipality2.averagePrice > 0
                      ? `${(180 * Number(calculatePercentage(municipality2.averagePrice, total)) / 100) + 140}px`
                      : "0px"}
                    inView={inView}
                    value={municipality2 ? Number(municipality2.averagePrice).toLocaleString('sv-SE') : 0}
                    label="tusen kronor"
                    lineColor={oppositeColor}
                    amount={municipality2.amount}
                  />
                </div>
              ) : (
                <SvgLayout width="50%">
                  <EmptySpace scroll={scroll} />
                </SvgLayout>
              )}
            </FiguresWrapper>
          </div>
        ) : null}
      </BlockLayout>
    </React.Fragment>
  );
};

AccommodationContainer.defaultProps = {
  data: []
};

export default AccommodationContainer;
